import React, { useContext } from 'react';
import { UseProductDetailsState, UseProductDetailsActor } from './useProductDetails';

/**
 * Context for product details
 */
export interface ProductDetailsContext {
	state: UseProductDetailsState;
	actor: UseProductDetailsActor;
}

const ProductDetailsContext = React.createContext<ProductDetailsContext | null>(null);

export default ProductDetailsContext;

/**
 * Custom hook for product details context
 */
export function useProductDetailsContext() {
	const context = useContext(ProductDetailsContext);

	if (context === null) {
		throw new Error('No ProductDetailsContext.Provider found.');
	}

	return context;
}
